<template>
  <div class="box">
    <h3 class="title">{{langData.title}}</h3>
    <p class="desc">{{langData.desc1}}</p>
    <p class="high"><span>{{langData.time1}}</span></p>
    <p class="high"><span>{{langData.time2}}</span></p>
    <p class="SDesc">{{langData.SDesc1}}</p>
    <p>{{langData.underDesc1}}</p>
    <div class="underDesc">
      <div v-for="(item) in langData.underDesc" :key="item">{{item}}</div>
    </div>
    <p class="TitleDesc">{{langData.TitleDesc1}}</p>
    <p class="SDesc">{{langData.SDesc2}}</p>
    <p class="desc">{{langData.desc2}}</p>
    <p class="desc">{{langData.desc3}}</p>
    <p class="desc">{{langData.desc4}}</p>
    <p class="SDesc">{{langData.SDesc3}}</p>
    <p> {{langData.ulDesc1}}</p>
    <ul class="ulDesc">
      <li>{{langData.liDesc1}}</li>
      <li>{{langData.liDesc2}}</li>
      <li>{{langData.liDesc3}}</li>
    </ul>
    <p class="desc">{{langData.desc5}}</p>
    <p class="TitleDesc">{{langData.TitleDesc2}}</p>
    <p class="SDesc">{{langData.SDesc4}}</p>
    <p class="desc">{{langData.desc6}}</p>
    <p class="SDesc">{{langData.SDesc5}}</p>
    <ul>
      <li v-for="item in langData.liDesc4" :key="item">{{item}}</li>
    </ul>
    <p class="SDesc">{{langData.SDesc6}}</p>
    <p class="desc">{{langData.desc7}}</p>
    <p class="SDesc">{{langData.SDesc7}}</p>
    <p class="desc">{{langData.desc8}}</p>
    <p> {{langData.ulDesc2}}</p>
    <ul>

      <li v-for="item in langData.liDesc5" :key="item">{{item}}</li>
    </ul>
    <p class="desc">{{langData.desc9}}</p>
    <p class="SDesc">{{langData.SDesc8}}</p>
    <p class="desc">{{langData.desc10}}</p>
    <p class="TitleDesc">{{langData.TitleDesc3}}</p>
    <p class="desc">{{langData.desc11}}</p>
    <p class="TitleDesc">{{langData.TitleDesc4}}</p>
    <p class="desc">{{langData.desc12}}</p>
    <p class="SDesc">{{langData.SDesc9}}</p>
    <ul>
      <li v-for="item in langData.liDesc6" :key="item">{{item}}</li>
    </ul>
    <p class="SDesc">{{langData.SDesc10}}</p>
    <p>
        {{langData.ulDesc3}}
    </p>
    <ul>

      <li v-for="item in langData.liDesc7" :key="item">{{item}}</li>
    </ul>
    <p class="SDesc">{{langData.SDesc11}}</p>
    <p> {{langData.ulDesc4}}</p>
    <ul>

      <li v-for="item in langData.liDesc8" :key="item">{{item}}</li>
    </ul>

    <p class="TitleDesc">{{langData.TitleDesc5}}</p>
    <p class="desc">{{langData.desc13}}</p>
    <p class="TitleDesc">{{langData.TitleDesc6}}</p>
    <p class="desc">{{langData.desc14}}</p>
    <p class="desc">{{langData.desc15}}</p>
    <p class="TitleDesc">{{langData.TitleDesc7}}</p>
    <p class="desc">{{langData.desc16}}</p>
    <p class="desc">{{langData.desc17}}</p>
    <p class="desc">{{langData.desc18}}</p>
    <p class="desc">{{langData.desc19}}</p>
    <p class="desc">{{langData.desc20}}</p>
    <p class="TitleDesc">{{langData.TitleDesc8}}</p>
    <p class="desc">{{langData.desc21}}</p>
    <p class="TitleDesc">{{langData.TitleDesc9}}</p>
    <p class="desc">{{langData.desc22}}</p>
    <p class="TitleDesc">{{langData.TitleDesc10}}</p>
    <p class="SDesc">{{langData.SDesc12}}</p>
    <ul>
      <li v-for="item in langData.liDesc9" :key="item">{{item}}</li>
    </ul>

    <p class="SDesc">{{langData.SDesc13}}</p>
    <p class="desc">{{langData.desc23}}</p>
    <p>   {{langData.ulDesc5}}</p>
      <ul>

      <li v-for="item in langData.liDesc10" :key="item">{{item}}</li>
    </ul>
    <p class="TitleDesc">{{langData.TitleDesc11}}</p>
    <p class="desc">{{langData.desc24}}</p>
    <p>   {{langData.ulDesc6}}</p>
       <ul>

      <li v-for="item in langData.liDesc11" :key="item">{{item}}</li>
    </ul>
    <p class="TitleDesc">{{langData.TitleDesc12}}</p>
    <p class="desc">
      {{langData.desc25}}
      <span>
        {{langData.highlightDesc1}}
      </span>

    </p>
    <p class="desc">{{langData.desc26}}</p>
    <p class="desc">{{langData.desc27}}</p>
  </div>
</template>

<script>
import en from "../assets/languageData";
export default {
  name: "singH5",
  data() {
    return {
      lang: "",
      langData: en
    };
  },
  methods: {},
  created() {},
  mounted() {}
};
</script>

<style scoped>
body{
    font-family: PingFangSC-Regular;
    line-height: 0.587rem;
    color: rgba(69,68,74,1);
}
div {
  font-size: 12px;
}
p {
  font-size: 12px;
  line-height: 16px;
}
.box {
  background-color: #fff;
  padding: 0 10px;
  overflow: auto;
}
.title {
  font-size: 20px;
  text-align: center;
  color: #222;
  margin: 1em 15px;
}
.desc {
  line-height: 20px;
  font-size: 15px;
  margin-bottom: 16px;
  color: rgba(69,68,74,1);
}
.box .high:nth-of-type(3) {
   margin-bottom: 16px;

}
.high span {
  background-color: yellow;
  font-weight: 600;
}
.SDesc {
  font-weight: 600;
  margin-bottom: 16px;
  font-size: 15px;
  margin-bottom: 16px;
  color: rgba(69,68,74,1);
}
.underDesc {
  text-decoration: underline;
  line-height: 18px;
  font-size: 12px;
}
.TitleDesc{
  color: #5B9BD5;
  font-size: 16px;
  margin: 1em 0;
}
ul {
  /* list-style: disc; */
  list-style-type: disc;
  line-height: 16px;
  padding-left: 20px;
}
li {
   /* list-style: disc; */
   list-style-type: disc;
  margin-bottom: 8px;


}
.desc span {
  background-color: yellow;
}
</style>



// WEBPACK FOOTER //
// src/components/singH5.vue